import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Translate from '../Translate/Translate.js';

import {
	ISearchConfiguration,
	ISearchResultGroupElementProps,
	ISearchResultGroupElementState,
} from './models/index.js';
import { SEARCH_CATEGORY_KEY, SEARCH_COMPONENT_KEY } from './Search.meta.js';

export class SearchResultGroupElement extends ComponentBase<
	ISearchResultGroupElementProps,
	ISearchResultGroupElementState,
	ISearchConfiguration
> {
	categoryKey = SEARCH_CATEGORY_KEY;
	componentKey = SEARCH_COMPONENT_KEY;

	componentDidMount() {
		this.setFocus();
	}

	componentDidUpdate() {
		this.setFocus();
	}

	setFocus() {
		const { item, isOpen } = this.props;
		if (isOpen && item && item.focused && item.ref) {
			item.ref.current.focus();
		}
	}

	render() {
		const { className, id, onClick, onKeyDown, item, role } = this.props;
		item.ref = React.createRef();
		return (
			<li
				className={className}
				id={id}
				onClick={onClick}
				onKeyDown={onKeyDown}
				role={role}
				ref={item.ref}
				tabIndex={0}
				aria-selected={item.focused}
			>
				<Translate>{item.value}</Translate>
			</li>
		);
	}
}

export default InjectedStyledComponent(observer(SearchResultGroupElement), SEARCH_CATEGORY_KEY, SEARCH_COMPONENT_KEY, [
	'resultGroupElement',
]);
